import { render, staticRenderFns } from "./_leaveBoard.vue?vue&type=template&id=51ee9c70&scoped=true"
import script from "./_leaveBoard.vue?vue&type=script&lang=js"
export * from "./_leaveBoard.vue?vue&type=script&lang=js"
import style0 from "./_leaveBoard.vue?vue&type=style&index=0&id=51ee9c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee9c70",
  null
  
)

export default component.exports